import { DEFAULT_TIME_ZONE } from "@/shared/time/zone";

export function zonedHour(d: Date, timeZone: string = DEFAULT_TIME_ZONE): number {
  return parseInt(zonedParts(d, timeZone).hh, 10) % 24;
}

export function zonedClockTime(d: Date, timeZone: string = DEFAULT_TIME_ZONE): string {
  const { hh, mm } = zonedParts(d, timeZone);
  return `${hh}:${mm}`;
}

export function zonedCalendarDay(d: Date, timeZone: string = DEFAULT_TIME_ZONE): string {
  const { year, month, day } = zonedParts(d, timeZone);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${year}-${pad(month)}-${pad(day)}`;
}

export function zonedStamp(
  iso: string,
  timeZone: string = DEFAULT_TIME_ZONE,
): { day: string; time: string } | null {
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return null;
  return { day: zonedCalendarDay(at, timeZone), time: zonedClockTime(at, timeZone) };
}

function zonedParts(
  d: Date,
  timeZone: string = DEFAULT_TIME_ZONE,
): {
  month: number;
  day: number;
  year: string;
  hh: string;
  mm: string;
} {
  const format = (tz: string) =>
    new Intl.DateTimeFormat("en-US", {
      timeZone: tz,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(d);

  let parts: Intl.DateTimeFormatPart[];
  try {
    parts = format(timeZone);
  } catch {
    parts = format(DEFAULT_TIME_ZONE);
  }
  const p = (t: string) => parts.find((x) => x.type === t)?.value ?? "";
  const hh = p("hour") === "24" ? "00" : p("hour");
  return {
    month: parseInt(p("month"), 10),
    day: parseInt(p("day"), 10),
    year: p("year"),
    hh,
    mm: p("minute"),
  };
}
